// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"449":"7c640e30","787":"e02c0aaf"}[chunkId] + ".chunk.js";
};